export enum RegisterFormControlName {
  EMAIL = 'email',
  COUNTRY = 'countryId',
  PASSWORD = 'password',
  REPEAT_PASSWORD = 'repeatPassword',
  TERM_CONDITIONS = 'termConditions',
  RECEIVE_PROMOTIONS = 'promotions'
}
